module.exports = __webpack_public_path__ + "img/time.097545de.svg";